import styled from 'styled-components';
import { InlineBanner, token } from '@bynder/design-system';

export const StyledInlineBanner = styled(InlineBanner)<{ withMargin: boolean }>`
    margin-bottom: ${(withMargin) => (withMargin ? token.spacing5 : 0)};
`;
